export default "__VITE_ASSET__CJo4CXDA__"